<template>
  <v-row justify="center">
    <v-dialog v-model="authAttemptDialog" scrollable max-width="350px">
      <v-card>
        <v-card-title>인증시도 이력 확인</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 500px;" class="pb-7">
          <template v-for="(item, key) in logList">
            <div :key="key">
              <p class="mb-0 font-weight-bold body-2 mt-9 black--text">
                <a :href="moveEcUserPage(item.member_id)" target="_blank">{{
                  item.member_id
                }}</a>
                님이 인증 시도하였습니다.
              </p>
              <p class="mb-0 caption text-truncate mt-1">
                <font>{{ item.tried_at }}</font>
              </p>
            </div>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="authAttemptDialog = false"
            >닫기</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      authAttemptDialog: false,
      logList: [],
    };
  },
  mixins: [CommonMixin],
  methods: {
    authAttempt: async function(item) {
      let res = await M.api(M.entry("/lost/serials/trial", item.serial_number));
      if (res.length === 0) {
        this.alertShow("인증시도 이력이 없습니다.");
      } else {
        this.logList = res;
        this.authAttemptDialog = true;
      }
    },
  },
};
</script>
